import ApplicationController from "./application_controller"
import GvToast from "../lib/gv_toast"
import { wireModalFormValidation } from "../lib/modal_form_validation"

export default class extends ApplicationController {
  connect() {
    this.loaderNode = document.getElementById("global-ajax-loader")

    this.clickHandler = this.handleRemoteClick.bind(this)
    document.addEventListener("click", this.clickHandler)

    this.closeHandler = this.closeTopModal.bind(this)
    document.addEventListener("givsum:modal:close", this.closeHandler)

    this.activeModalsStack = []
    this.isLoading = false
  }

  disconnect() {
    document.removeEventListener("click", this.clickHandler)
    document.removeEventListener("givsum:modal:close", this.closeHandler)
  }

  closeTopModal() {
    const top = this.activeModalsStack[this.activeModalsStack.length - 1]
    if (top) top.instance.hide()
  }

  handleRemoteClick(event) {
    // Also answers plain .modal-ajax triggers -- global_modal_controller.js is disconnected (see index.js), this is now the one modal system.
    const trigger = event.target.closest(".modal-ajax-v3, .modal-ajax")
    if (!trigger) return
    if (event.globalModalV3Handled) return
    event.globalModalV3Handled = true

    event.preventDefault()
    event.stopPropagation()

    if (this.isLoading) return

    const requestUrl = trigger.getAttribute("href")
    if (!requestUrl || requestUrl === "#") return

    document.querySelectorAll(".tooltip, .popover").forEach((el) => el.remove())

    const modalTitle = trigger.dataset.modalTitle || "Givsum Action"
    const modalSize = trigger.dataset.modalSize || ""

    this.showSpinner()
    this.fetchAndSpawn(requestUrl, modalTitle, modalSize)
  }

  async fetchAndSpawn(url, title, size) {
    try {
      this.isLoading = true
      const response = await fetch(url, {
        headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "text/html" },
      })
      if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)

      const responseMarkup = await response.text()
      this.hideSpinner()

      this.createNewModalInstance(responseMarkup, title, size)
    } catch (error) {
      console.error("global-modal-v3 fetch error:", error)
      this.hideSpinner()
      GvToast.error("The content could not be loaded.")
    } finally {
      this.isLoading = false
    }
  }

  createNewModalInstance(markup, initialTitle, size) {
    const modalId = `modal-v3-${Date.now()}`

    const parser = new DOMParser()
    const doc = parser.parseFromString(markup, "text/html")

    const titleOverrideNode = doc.querySelector("[data-modal-title-override]")
    let finalTitle = initialTitle
    if (titleOverrideNode) {
      finalTitle = titleOverrideNode.textContent.trim()
      titleOverrideNode.remove()
    }

    const footerNode = doc.querySelector(".modal-footer")
    let footerHTML = ""
    if (footerNode) {
      footerHTML = footerNode.outerHTML
      footerNode.remove()
    }

    const bodyHTML = doc.body ? doc.body.innerHTML : markup

    const template = `
      <div class="modal fade" id="${modalId}" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ${size}">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">${finalTitle}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              ${bodyHTML}
            </div>
            ${footerHTML}
          </div>
        </div>
      </div>
    `

    document.body.insertAdjacentHTML("beforeend", template)
    const element = document.getElementById(modalId)

    // Manage visual depth indexes explicitly if multiple layers stack
    if (this.activeModalsStack.length > 0) {
      element.classList.add("stack-level-up")
      element.style.zIndex = 1055 + this.activeModalsStack.length * 10
    }

    const bsInstance = new bootstrap.Modal(element, {
      // Stacked layers skip the backdrop entirely so darkness doesn't compound.
      backdrop: this.activeModalsStack.length > 0 ? false : "static",
    })
    bsInstance.show()

    this.activeModalsStack.push({ element, instance: bsInstance })

    wireModalFormValidation(element)
    this.executeInjectedScripts(element, doc)

    element.addEventListener("hidden.bs.modal", () => {
      bsInstance.dispose()
      element.remove()
      this.activeModalsStack = this.activeModalsStack.filter((item) => item.element !== element)
      if (this.activeModalsStack.length > 0) {
        document.body.classList.add("modal-open")
      }
    })
  }

  executeInjectedScripts(modalElement, parsedDoc) {
    const scripts = parsedDoc.querySelectorAll("script")

    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script")

      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value)
      })

      newScript.textContent = oldScript.textContent

      modalElement.appendChild(newScript)
    })
  }

  showSpinner() {
    if (this.loaderNode) this.loaderNode.classList.remove("d-none")
  }

  hideSpinner() {
    if (this.loaderNode) this.loaderNode.classList.add("d-none")
  }
}
